export default __webpack_public_path__ + "static/media/smtl.66c83eff.png";